module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/foreground_tablet-ede4e26c3e20fd24806f70530c6ff4b4.png";